import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroupComp from "@mui/material/RadioGroup";
import { useEffect, useState } from "react";

const RadioGroup = (props) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(props.defaultValue);
  }, [props.defaultValue]);

  const hStyle = {
    display: "flex",
    alignItems: "center",
    // width: "100%",
    marginTop: props.marginTop, // was "0.625rem"
    marginRight: props.marginRight, // was "0.625rem"
  };

  const radioBoxStyle = (data, idx) => {
    let marginRight = props.radioMarginRight ? props.radioMarginRight : "1.25rem";
    if (data.length - 1 === idx) {
      marginRight = "0rem";
    }

    return {
      margin: "0",
      marginRight: marginRight,
      marginLeft: props.radioMarginLeft ? props.radioMarginLeft : "",
      padding: "0",
    };
  };

  const labelStyle = {
    width: props.labelWidth,
    height: "2.25rem",
    marginRight: "0.625rem",
    marginLeft: props.labelMarginLeft,
    fontFamily: "AppleSDGothicNeo",
    fontSize: "0.938rem",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#000",
    alignItems: "center",
    display: "flex",
  };
  const radioStyle = {
    width: "100%",
    // width: "2.25rem",
    // height: "2.25rem",
    // transform: "scale(1.2)",
    // marginRight: "0.562rem",
    // marginLeft: props.ItemMarginLeft,
  };

  const radioLabelStyle = (item) => {
    let color = "#000";
    if (props.disabled || (props.disableItem && props.disableItem.indexOf(item) !== -1)) {
      color = "#999";
    }

    return {
      fontFamily: "AppleSDGothicNeo",
      fontSize: "0.938rem",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      textAlign: "left",
      color: color,
      alignItems: "center",
      marginLeft: "0.25rem",
    };
  };

  const onChangeValue = (e, value) => {
    setValue(e.target.value);
    if (props.inputRef !== undefined) {
      props.inputRef.current = value;
    }
    if (props.onChangeCallback !== undefined) {
      props.onChangeCallback(e, value);
    }
  };

  const Radios = () => {
    if (!props.data) return null;

    return props.data.map((item, idx) => (
      <FormControlLabel
        key={idx}
        value={item}
        style={radioBoxStyle(props.data, idx)}
        control={
          <Radio
            disabled={
              props.disabled || (props.disableItem && props.disableItem.indexOf(item) !== -1)
            }
            sx={{ padding: "0.25rem", marginLeft: "0.625rem" }}
          />
        }
        label={props.isMulti === undefined ? "" : <div style={radioLabelStyle(item)}>{item}</div>}
      />
    ));
  };

  return (
    <Box style={hStyle}>
      <div style={labelStyle}>
        <div>{props.labelText}</div>
      </div>
      <RadioGroupComp
        row
        aria-label="gender"
        name="radioButtonsGroup"
        onChange={onChangeValue}
        style={radioStyle}
        defaultValue={props.defaultValue}
        value={value}
      >
        <Radios />
      </RadioGroupComp>
    </Box>
  );
};

export default RadioGroup;
